import { VStack } from "@chakra-ui/react";
import { Field, FormInput, FormTextarea } from "@/components/jobOffer/ui/inputs";
import { SectionCard, SectionHeader, Divider, Grid2, SubsectionTitle } from "@/components/jobOffer/ui/layout";
import { RepeatableText } from "@/components/jobOffer/ui/listHelpers";

const StepCompanyKnowledge = ({ values, onChange }) => {
    const setCompanyInfo = (key, val) => onChange({ ...values, companyInfo: { ...values.companyInfo, [key]: val } });

    return (
        <VStack w="full" align="stretch" gap={4}>
            <SectionCard>
                <SectionHeader number={1} title="Informacje o firmie" subtitle="Baza wiedzy, z której korzysta Agent" />
                <VStack align="stretch" gap={4}>
                    <Grid2>
                        <Field label="Nazwa firmy">
                            <FormInput value={values.companyInfo?.companyName ?? ""} onChange={(e) => setCompanyInfo("companyName", e.target.value)} />
                        </Field>
                        <Field label="Marka">
                            <FormInput value={values.companyInfo?.brand ?? ""} onChange={(e) => setCompanyInfo("brand", e.target.value)} />
                        </Field>
                    </Grid2>
                    <Grid2>
                        <Field label="Strona WWW">
                            <FormInput value={values.companyInfo?.website ?? ""} onChange={(e) => setCompanyInfo("website", e.target.value)} />
                        </Field>
                        <Field label="Obszar działania">
                            <FormInput value={values.companyInfo?.serviceArea ?? ""} onChange={(e) => setCompanyInfo("serviceArea", e.target.value)} />
                        </Field>
                    </Grid2>
                    <Field label="Krótki opis firmy">
                        <FormTextarea value={values.companyInfo?.shortDescription ?? ""} onChange={(e) => setCompanyInfo("shortDescription", e.target.value)} rows={2} />
                    </Field>
                    <Field label="Czym firma się zajmuje">
                        <FormTextarea value={values.companyInfo?.whatWeDo ?? ""} onChange={(e) => setCompanyInfo("whatWeDo", e.target.value)} rows={2} />
                    </Field>
                    <Field label="Dlaczego klient powinien wybrać firmę">
                        <FormTextarea value={values.companyInfo?.whyChooseUs ?? ""} onChange={(e) => setCompanyInfo("whyChooseUs", e.target.value)} rows={2} />
                    </Field>
                    <Field label="Doświadczenie">
                        <FormTextarea value={values.companyInfo?.experience ?? ""} onChange={(e) => setCompanyInfo("experience", e.target.value)} rows={2} />
                    </Field>
                    <Divider />
                    <SubsectionTitle>Przewagi, referencje, certyfikaty</SubsectionTitle>
                    <Grid2>
                        <RepeatableText label="Najważniejsze przewagi" values={values.companyInfo?.keyAdvantages ?? []} onChange={(v) => setCompanyInfo("keyAdvantages", v)} placeholder="Przewaga" />
                        <RepeatableText label="Referencje" values={values.companyInfo?.references ?? []} onChange={(v) => setCompanyInfo("references", v)} placeholder="Referencja" />
                        <RepeatableText label="Certyfikaty" values={values.companyInfo?.certificates ?? []} onChange={(v) => setCompanyInfo("certificates", v)} placeholder="Certyfikat" />
                        <RepeatableText label="Nagrody" values={values.companyInfo?.awards ?? []} onChange={(v) => setCompanyInfo("awards", v)} placeholder="Nagroda" />
                        <RepeatableText label="Partnerzy" values={values.companyInfo?.partners ?? []} onChange={(v) => setCompanyInfo("partners", v)} placeholder="Partner" />
                        <RepeatableText label="Lokalizacje" values={values.companyInfo?.locations ?? []} onChange={(v) => setCompanyInfo("locations", v)} placeholder="Lokalizacja" />
                    </Grid2>
                    <Field label="Godziny działania">
                        <FormInput value={values.companyInfo?.operatingHours ?? ""} onChange={(e) => setCompanyInfo("operatingHours", e.target.value)} />
                    </Field>
                </VStack>
            </SectionCard>
        </VStack>
    );
};

export default StepCompanyKnowledge;
